import { render, staticRenderFns } from "./DDEX.vue?vue&type=template&id=ca47aa9c&scoped=true"
import script from "./DDEX.vue?vue&type=script&lang=js"
export * from "./DDEX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca47aa9c",
  null
  
)

export default component.exports